import { APP_INITIALIZER, LOCALE_ID, ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LanguagesSelectorComponent } from './languages-selector.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { LocalizationService } from 'src/app/services/localization/localization.service';
import { LocalizationConfigService } from 'src/app/services/localization/localization-config.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [],
  imports: [CommonModule,
    HttpClientModule,
    FormsModule,
    TranslateModule.forChild()],
  exports: [TranslateModule]
})
export class LanguagesSelectorModule {
  public static forRoot(config: any): ModuleWithProviders<LanguagesSelectorModule> {
    return {
      ngModule: LanguagesSelectorModule,
      providers: [
        {
          provide: APP_INITIALIZER,
          useFactory: initLocalizationService,
          deps: [LocalizationService],
          multi: true
        },
        LocalizationService,
        { provide: LOCALE_ID, useValue: config.locale_id },
        { provide: LocalizationConfigService, useValue: config }
      ]
    };
  }
}

@NgModule({
  declarations: [LanguagesSelectorComponent],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [TranslateModule, LanguagesSelectorComponent],
  providers: []
})
export class InternationalizationLanguagesModule { }


/**
  * Initialize the localization service.
  * @param {LocalizationService} service
  * @returns {() => Promise<void>}
  */
export function initLocalizationService(service: LocalizationService) {
  return () => service.initService();
}